module.exports = __webpack_public_path__ + "media/images/categories/color/apr-8f3ab312f6d7b34889d0b266e826ee45.png";